import React from 'react';
import './Intro.css';

function Intro() {
  return (
    <div id='intro'>
        <p>A new support hub for people with sight loss based in Derby is launching soon. Here you can find advice, signposting and assistance to develop a new vision for your sight loss journey. The vision loss hub aims to connect you with the local service providers and peer groups to build your confidence as a way forward.</p>
        <p>With this hub you will meet people with sight loss who have lived-in experience of the challenges we face.</p>
    </div>
  )
}

export default Intro